(function () {
'use strict';

var prevHeight = window.innerHeight;

var updateAppHeight = function updateAppHeight() {
    document.documentElement.style.setProperty('--app-height', window.innerHeight + 'px');
};
window.addEventListener('resize', function () {
    if (window.innerHeight !== prevHeight) {
        prevHeight = window.innerHeight;
        updateAppHeight();
    }
});

updateAppHeight();

// inicializace objektu pro ukládání balíčků
if (!window.packageStore) {
    window.packageStore = {};
}

window.initPackage = function (url) {
    return new Promise(function (resolve, reject) {
        // kontrola, zda balíček již byl načten
        if (window.packageStore[url]) {
            resolve(window.packageStore[url]);
        } else {
            // inicializace balíčku
            var script = document.createElement('script');
            //window.packageStore[url] = true;
            script.onload = function () {
                window.packageStore[url] = true;
                resolve(true);
            };
            script.onerror = function () {
                reject(new Error('Nepodařilo se načíst balíček.'));
            };
            script.src = url;
            document.head.appendChild(script);
        }
    });
};

window.initPackages = function (scriptUrls) {
    var promises = [];

    scriptUrls.forEach(function (url) {
        if (!window.packageStore[url]) {
            promises.push(window.initPackage(url));
        }
    });

    return Promise.all(promises);
};

function loader() {
    var loading = document.querySelector('body.loading');
    if (loading) {
        if (loading.classList.contains('loading')) {
            loading.classList.add('loading--finished');

            setTimeout(function () {
                loading.classList.remove('loading--finished');
                loading.classList.remove('loading');

                document.dispatchEvent(new CustomEvent('bodyLoadingFinished'));
            }, 120);
        }
    }
}

if (document.readyState === 'loading') {
    // Loading hasn't finished yet
    document.addEventListener('DOMContentLoaded', loader);
} else {
    // `DOMContentLoaded` has already fired
    loader();
}

var mobileMenu = {
    init: function init() {
        var self = this;
        var scriptUrl = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/gsap.min.js';

        var menu = document.querySelector('.c-navbar-mobile');

        if (!menu && window.innerWidth < 1200) {
            return;
        }

        window.initPackage(scriptUrl).then(function () {
            self._initMenu();
        }).catch(function (error) {
            console.error(error);
        });
    },
    _initMenu: function _initMenu() {
        var self = this;
        self._initDropdown();

        self.menuNode = document.querySelector('.c-navbar-mobile');
        self.openButton = self.menuNode.querySelector('.js-burger');
        self.closeButton = self.menuNode.querySelector('.js-close');
        self.menu = self.menuNode.querySelector('.c-navbar-mobile__content');

        var body = document.querySelector('body');
        if (body.classList.contains('body-fixed')) {
            body.classList.remove('body-fixed');
        }

        self.openMenuReference = self._openMenu.bind(null, self);
        self.openButton.addEventListener('click', self.openMenuReference, false);

        self.closeMenuReference = self._closeMenu.bind(null, self);
        self.closeButton.addEventListener('click', self.closeMenuReference, false);
    },
    _openMenu: function _openMenu(self) {
        if (!self.menu.classList.contains('c-navbar-mobile__content--hidden')) {
            return;
        }

        self.menu.classList.remove('c-navbar-mobile__content--hidden');
        document.querySelector('body').classList.add('body-fixed');
        gsap.from(self.menu, { duration: 0.3, autoAlpha: 0, right: '-100%' });

        self.openButton.classList.remove('c-navbar-mobile__opened');
        self.openButton.classList.add('c-navbar-mobile__closed');
        self.closeButton.classList.add('c-navbar-mobile__opened');
        self.closeButton.classList.remove('c-navbar-mobile__closed');
    },
    _closeMenu: function _closeMenu(self) {
        if (self.menu.classList.contains('c-navbar-mobile__content--hidden')) {
            return;
        }

        self.openButton.classList.add('c-navbar-mobile__opened');
        self.openButton.classList.remove('c-navbar-mobile__closed');
        self.closeButton.classList.remove('c-navbar-mobile__opened');
        self.closeButton.classList.add('c-navbar-mobile__closed');

        gsap.to(self.menu, { duration: 0.2, autoAlpha: 0, right: '-100%', onComplete: function onComplete() {
                self.menu.classList.add('c-navbar-mobile__content--hidden');
                self.menu.removeAttribute('style');
            } });
    },
    _initDropdown: function _initDropdown() {
        var dropDowns = document.querySelectorAll('.c-navbar-mobile .c-navbar__nav-item-dropdown');

        dropDowns.forEach(function (dropDown) {
            dropDown.addEventListener('click', function () {
                var dropDownContent = dropDown.parentElement.querySelector('.c-navbar-dropdown-menu__content');
                if (dropDownContent.classList.contains('c-navbar-dropdown-menu__content--closed')) {
                    dropDownContent.classList.remove('c-navbar-dropdown-menu__content--closed');
                    dropDownContent.classList.add('c-navbar-dropdown-menu__content--opened');

                    dropDown.parentElement.classList.add('c-navbar-dropdown-menu__arrow--opened');

                    if (dropDown.parentElement.querySelector('a').getAttribute('aria-expanded') === 'false') {
                        dropDown.parentElement.querySelector('a').setAttribute('aria-expanded', 'true');
                    }
                } else {
                    dropDownContent.classList.add('c-navbar-dropdown-menu__content--closed');
                    dropDownContent.classList.remove('c-navbar-dropdown-menu__content--opened');

                    dropDown.parentElement.classList.remove('c-navbar-dropdown-menu__arrow--opened');

                    if (dropDown.parentElement.querySelector('a').getAttribute('aria-expanded') === 'true') {
                        dropDown.parentElement.querySelector('a').setAttribute('aria-expanded', 'false');
                    }
                }
            });
        });
    },
    _destroyMenu: function _destroyMenu() {
        var self = this;

        if (self.openButton) {
            self.openButton.removeEventListener('click', self.openMenuReference, false);
        }

        if (self.closeButton) {
            self.closeButton.removeEventListener('click', self.closeMenuReference, false);
        }
    },
    reInit: function reInit() {
        var self = this;

        self._closeMenu(self);
        self._destroyMenu();
        self.init();
    }
};

mobileMenu.init();

/*window.addEventListener('resize', function() {
    // clear the timeout
    clearTimeout(mobileMenu.timeout);
    // start timing for event "completion"
    mobileMenu.timeout = setTimeout(mobileMenu.getDimension(), mobileMenu.delay);
});*/

document.addEventListener('LokiRequestEnd', function () {
    mobileMenu.reInit();
});

var accordionComponent = {
    init: function init() {
        var accordions = document.querySelectorAll('.c-accordion-description');

        if (!accordions.length) {
            return;
        }
        var self = this;

        self._behaviour(accordions);
    },
    showContent: function showContent(showButton) {
        var accordion = showButton.closest('.c-accordion-description');
        var accordionContentHeight = accordion.querySelector('.c-accordion-description__content-inner').offsetHeight;
        accordion.querySelector('.c-accordion-description__content').style = "height:" + accordionContentHeight + "px;";
        showButton.classList.add('u-display--none');

        var hideButton = accordion.querySelector('.c-accordion-description--hide-more');
        hideButton.classList.remove('u-display--none');
    },
    hideContent: function hideContent(hideButton) {
        var accordion = hideButton.closest('.c-accordion-description');
        accordion.querySelector('.c-accordion-description__content').removeAttribute('style');
        hideButton.classList.add('u-display--none');

        var showButton = accordion.querySelector('.c-accordion-description--show-more');
        showButton.classList.remove('u-display--none');
    },
    _behaviour: function _behaviour(accordions) {
        accordions.forEach(function (accordion) {
            var accordionContent = accordion.querySelector('.c-accordion-description__content-inner');
            var accordionButtonsWrapper = accordion.querySelector('.c-accordion-description__buttons-wrapper');

            if (accordionContent.offsetHeight < 68 && window.innerWidth < 768) {
                accordionButtonsWrapper.classList.add('u-display--none');
            }

            if (accordionContent.offsetHeight < 55 && window.innerWidth > 768) {
                accordionButtonsWrapper.classList.add('u-display--none');
            }
        });
    }
};

window.accordionComponent = accordionComponent;

window.accordionComponent.init();

document.addEventListener('LokiRequestEnd', function () {
    window.accordionComponent.init();
});

var accordionDefault = {
    init: function init() {
        var accordionNodes = document.querySelectorAll('.c-accordion-shortcode');

        if (!accordionNodes.length) {
            return;
        }
        var self = this;

        accordionNodes.forEach(function (accordionNode) {
            self._responsiveBehaviour(accordionNode);
        });
    },
    toggleContent: function toggleContent(button) {
        var accordionNode = button.parentElement;

        if (accordionNode.classList.contains('c-accordion-shortcode--opened')) {
            accordionNode.querySelector('.c-accordion-shortcode__content').style.height = '0px';
            accordionNode.classList.remove('c-accordion-shortcode--opened');
        } else {
            accordionNode.querySelector('.c-accordion-shortcode__content').style.height = accordionNode.dataset.contentHeight + 'px';
            accordionNode.classList.add('c-accordion-shortcode--opened');
        }
    },
    _responsiveBehaviour: function _responsiveBehaviour(accordionNode) {
        accordionNode.dataset.contentHeight = accordionNode.querySelector('.c-accordion-shortcode__content-inner').offsetHeight;
    }
};

window.accordionDefault = accordionDefault;

window.accordionDefault.init();

document.addEventListener('LokiRequestEnd', function () {
    window.accordionDefault.init();
});

var contentStructure = {
    init: function init() {
        var contentStructure = document.querySelector('.c-content-structure');

        if (!contentStructure) {
            return;
        }
        var self = this;

        self._responsiveBehaviour(contentStructure);
    },
    toggleContent: function toggleContent(button) {
        var contentStructure = button.parentElement;

        if (contentStructure.classList.contains('c-content-structure--opened')) {
            contentStructure.querySelector('.c-content-structure__content').style.height = '0px';
            contentStructure.classList.remove('c-content-structure--opened');
        } else {
            contentStructure.querySelector('.c-content-structure__content').style.height = contentStructure.dataset.contentHeight + 'px';
            contentStructure.classList.add('c-content-structure--opened');
        }
    },
    _responsiveBehaviour: function _responsiveBehaviour(contentStructure) {
        var contentHeight = contentStructure.querySelector('.c-content-structure__content-list').offsetHeight;
        contentStructure.dataset.contentHeight = parseFloat(contentHeight) + 18;
        //contentStructure.querySelector('.c-content-structure__content').style.height = contentHeight + 18 + 'px';
        //contentStructure.classList.add('c-content-structure--opened');
    }
};

window.contentStructure = contentStructure;

window.contentStructure.init();

document.addEventListener('LokiRequestEnd', function () {
    window.contentStructure.init();
});

var gallery = {
    _articleGallery: null,
    _gallery: null,

    init: function init() {
        var self = this;
        if (!document.querySelector('.js-gallery') && !document.querySelector('.c-typography') && !document.querySelector('.js-mosaic-gallery')) {
            return;
        }

        var scriptUrls = ['https://cdn.jsdelivr.net/npm/lightgallery@2.7.1/lightgallery.min.js', 'https://cdn.jsdelivr.net/npm/lightgallery@2.7.1/plugins/zoom/lg-zoom.min.js', 'https://cdn.jsdelivr.net/npm/lightgallery@2.7.1/plugins/thumbnail/lg-thumbnail.min.js'];

        window.initPackages(scriptUrls).then(function () {
            self._galleriesCreate();
        }).catch(function (error) {
            console.error(error);
        });
    },

    _galleriesCreate: function _galleriesCreate() {
        var self = this;
        var gallery = document.querySelector('.js-gallery');
        var articleGallery = document.querySelector('.c-typography');
        var mosaic = document.querySelectorAll('.js-mosaic-gallery');

        if (articleGallery) {
            var items = articleGallery.querySelectorAll('img');
            items.forEach(function (item) {
                if (item.closest('a') || item.closest('.c-ideal-usage-tip-shortcode')) {
                    item.classList.add('no-resize');
                }
            });

            self._articleGallery = lightGallery(articleGallery, {
                selector: articleGallery.querySelectorAll('img:not(.no-resize)'),
                plugins: [lgZoom, lgThumbnail],
                licenseKey: '32088F1F-749D4338-9276BA7C-4A5EF243',
                speed: 500,
                exThumbImage: 'data-external-thumb-image'
            });
        }

        if (gallery) {
            self._gallery = lightGallery(gallery, {
                selector: gallery.querySelectorAll('a'),
                download: true,
                preload: 1,
                licenseKey: '32088F1F-749D4338-9276BA7C-4A5EF243',
                plugins: [lgZoom, lgThumbnail],
                exThumbImage: 'data-external-thumb-image'
            });
        }

        if (mosaic.length > 0) {
            mosaic.forEach(function (gallery) {
                lightGallery(gallery, {
                    download: true,
                    preload: 1,
                    licenseKey: '32088F1F-749D4338-9276BA7C-4A5EF243',
                    plugins: [lgZoom, lgThumbnail],
                    selector: '.c-mosaic__item a'
                });
            });
        }
    },
    _destroy: function _destroy() {
        if (self._articleGallery) {
            self._articleGallery.destroy();
        }

        if (self._gallery) {
            self._gallery.destroy();
        }

        this.init();
    }
};

window.gallery = gallery;
window.gallery.init();

document.addEventListener('LokiRequestEnd', function () {
    window.gallery._destroy();
});

window.commentsFormToggle = function (node) {
    var allFormsNode = node.closest('.c-comments-wrapper').querySelectorAll('.c-comments__item-form--visible');
    var skip = false;

    if (node.closest('.c-comments__item').querySelector('.c-comments__item-form').classList.contains('c-comments__item-form--visible')) {
        skip = true;
    }

    allFormsNode.forEach(function (itemNode) {
        if (itemNode.classList.contains('c-comments__item-form--visible')) {
            itemNode.classList.remove('c-comments__item-form--visible');
        }
    });

    if (!skip) {
        node.closest('.c-comments__item').querySelector('.c-comments__item-form').classList.toggle('c-comments__item-form--visible');
    }
};

var accordionProduct = {
    init: function init() {

        if (window.innerWidth >= 1200) {
            return;
        }

        var accordionNodes = document.querySelectorAll('.c-accordion-product-detail');

        if (!accordionNodes.length) {
            return;
        }

        var self = this;

        accordionNodes.forEach(function (accordionNode) {
            self._responsiveBehaviour(accordionNode);
        });
    },
    toggleContent: function toggleContent(button) {

        if (window.innerWidth >= 1200) {
            return;
        }

        var accordionNode = button.parentElement;

        if (accordionNode.classList.contains('c-accordion-product-detail--closed')) {
            accordionNode.querySelector('.c-accordion-product-detail__content').style.height = accordionNode.dataset.contentHeight + 'px';
            accordionNode.classList.remove('c-accordion-product-detail--closed');
        } else {
            accordionNode.querySelector('.c-accordion-product-detail__content').style.height = '0px;';
            accordionNode.classList.add('c-accordion-product-detail--closed');
        }
    },
    _responsiveBehaviour: function _responsiveBehaviour(accordionNode) {
        accordionNode.dataset.contentHeight = accordionNode.querySelector('.c-accordion-product-detail__content-inner').offsetHeight;
    }
};

window.accordionProduct = accordionProduct;

window.accordionProduct.init();

document.addEventListener('LokiRequestEnd', function () {
    window.accordionProduct.init();
});

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var ImageSlider = function () {
    function ImageSlider(node, index) {
        classCallCheck(this, ImageSlider);

        var self = this;
        self.sliderNode = node;
        self.index = index;
        self.galleryNode = self.sliderNode.querySelector('.js-image-slider-gallery');
        self.build();
    }

    createClass(ImageSlider, [{
        key: 'build',
        value: function build() {
            var self = this;
            self._createSlider();

            if (self.galleryNode) {
                self._createGallery();
            }
        }
    }, {
        key: 'destroyAll',
        value: function destroyAll() {
            var self = this;

            if (self.slider) {
                self.destroySlider();
                self._destroyButtonsEvent();
            }

            if (self.gallery) {
                setTimeout(function () {
                    self.gallery = null;
                    self.index = null;
                }, self.destroyGallery());
            }

            self.slider = null;

            self.sliderNode = null;
        }
    }, {
        key: 'destroySlider',
        value: function destroySlider() {
            var self = this;
            self._destroyButtonsEvent();
            self.slider.destroy(true);
            self.slider = null;
            self.sliderNode = null;
        }
    }, {
        key: 'destroyGallery',
        value: function destroyGallery() {
            var self = this;
            return self.gallery.destroy();
        }
    }, {
        key: 'goTo',
        value: function goTo(index) {
            var self = this;
            self.slider.go(index);
        }
    }, {
        key: 'openGallery',
        value: function openGallery(index) {
            var self = this;
            self.gallery.openGallery(index);
        }
    }, {
        key: 'nextSlide',
        value: function nextSlide(self) {
            self.slider.go('>');
        }
    }, {
        key: 'prevSlide',
        value: function prevSlide(self) {
            self.slider.go('<');
        }
    }, {
        key: '_createSlider',
        value: function _createSlider() {
            var self = this;
            self.slider = new Splide(self.sliderNode, {
                type: 'slide',
                perPage: 1,
                clones: 0,
                arrows: false,
                pagination: false,
                breakpoints: {
                    768: {
                        pagination: true
                    }
                }

            }).mount();
            self._navigation();
            self._initClickEvent();
        }
    }, {
        key: '_createGallery',
        value: function _createGallery() {
            var self = this;
            if (self.galleryNode) {
                self.gallery = lightGallery(self.galleryNode, {
                    download: false,
                    preload: 1,
                    plugins: [lgZoom, lgThumbnail],
                    licenseKey: '32088F1F-749D4338-9276BA7C-4A5EF243'
                });
            }
        }
    }, {
        key: '_initClickEvent',
        value: function _initClickEvent() {
            var self = this;

            self.nextButton = self.sliderNode.querySelector('.c-slider__nav-next');
            self.prevButton = self.sliderNode.querySelector('.c-slider__nav-prev');

            self.fakePrevButton = self.sliderNode.querySelector('.c-slider__fake-nav--left');
            self.fakeNextButton = self.sliderNode.querySelector('.c-slider__fake-nav--right');

            if (self.nextButton) {
                self.nextButtonReference = self.nextSlide.bind(null, self);
                self.nextButton.addEventListener('click', self.nextButtonReference, false);
            }

            if (self.prevButton) {
                self.prevButtonReference = self.prevSlide.bind(null, self);
                self.prevButton.addEventListener('click', self.prevButtonReference, false);
            }

            if (self.fakePrevButton) {
                self.fakePrevButton.addEventListener('click', self.prevSlide, false);
            }

            if (self.fakeNextButton) {
                self.fakeNextButton.addEventListener('click', self.nextSlide, false);
            }
        }
    }, {
        key: '_destroyButtonsEvent',
        value: function _destroyButtonsEvent() {
            var self = this;

            if (self.nextButton && self.prevButton) {
                self.nextButton.removeEventListener('click', self.nextSlide, false);
                self.prevButton.removeEventListener('click', self.prevSlide, false);
            }

            if (self.fakeNextButton && self.fakePrevButton) {
                self.fakePrevButton.removeEventListener('click', self.nextSlide, false);
                self.fakeNextButton.removeEventListener('click', self.prevSlide, false);
            }

            self.nextButton = null;
            self.prevButton = null;
            self.fakeNextButton = null;
            self.fakePrevButton = null;
        }
    }, {
        key: '_navigation',
        value: function _navigation() {
            var self = this;

            if (window.innerWidth < 768) {
                return;
            }

            var navigationWrapper = self.sliderNode.parentElement.querySelector('.c-image-slider-nav');

            var navigationItems = navigationWrapper.querySelectorAll('.c-image-slider-nav__item');

            if (navigationItems.length >= 1) {
                navigationItems.forEach(function (item, index) {
                    if (navigationWrapper.closest('.c-product-detail__slider')) {
                        if (index >= 6 && navigationItems.length - 1 === index) {
                            item.setAttribute('onclick', 'window.imageSlider.sliderObjects[' + self.index + '].openGallery(' + index + ');');
                            item.dataset.count = self.slider.length - index;
                            return;
                        }
                    } else {
                        if (index >= 3 && navigationItems.length - 1 === index) {
                            item.setAttribute('onclick', 'window.imageSlider.sliderObjects[' + self.index + '].openGallery(' + index + ');');
                            item.dataset.count = self.slider.length - index;
                            return;
                        }
                    }

                    item.setAttribute('onclick', 'window.imageSlider.sliderObjects[' + self.index + '].goTo(' + index + ')');
                });
            }
        }
    }]);
    return ImageSlider;
}();

var imageSlider = {
    sliderObjects: [],

    init: function init() {
        var self = this;
        var sliderNodes = document.querySelectorAll('.js-image-slider');

        if (!sliderNodes.length) {
            return;
        }

        var scriptUrls = ['https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js', 'https://cdn.jsdelivr.net/npm/lightgallery@2.7.1/lightgallery.min.js', 'https://cdn.jsdelivr.net/npm/lightgallery@2.7.1/plugins/zoom/lg-zoom.min.js', 'https://cdn.jsdelivr.net/npm/lightgallery@2.7.1/plugins/thumbnail/lg-thumbnail.min.js'];

        window.initPackages(scriptUrls).then(function () {
            sliderNodes.forEach(function (sliderNode, index) {
                self.sliderObjects[index] = new ImageSlider(sliderNode, index);
            });
        }).catch(function (error) {
            console.error(error);
        });
    },
    reInit: function reInit() {
        var self = this;
        var timeout = 1;

        if (self.sliderObjects.length) {
            self.sliderObjects.forEach(function (sliderObject) {
                sliderObject.destroySlider();
                var currentTimeout = sliderObject.destroyGallery();
                if (currentTimeout > timeout) {
                    timeout = currentTimeout;
                }

                setTimeout(function () {
                    sliderObject.gallery = null;
                    sliderObject.index = null;
                }, currentTimeout);
            });
        }

        setTimeout(function () {
            self.sliderObjects = [];
            self.init();
        }, timeout);
    }
};

window.imageSlider = imageSlider;
window.imageSlider.init();

document.addEventListener('LokiRequestEnd', function () {
    window.imageSlider.reInit();
});

var searchResultsFiltration = {
    input: null,
    searchWrapper: null,
    options: null,

    init: function init() {

        var self = this;

        self.searchWrapper = document.querySelector('.c-search-bar-barber-shops');

        if (!self.searchWrapper) {
            return;
        }

        self._fireInput();
    },
    reInit: function reInit() {
        var self = this;

        if (self.input !== null) {

            self.input.removeEventListener('click', self.inputClickReference, false);
            self.input.removeEventListener('input', self.inputInputEventReference, false);
            window.removeEventListener('click', self.outerClickReference, false);
            self.searchWrapper = null;
            self.input = null;
        }

        if (document.querySelector('.c-search-bar-barber-shops')) {
            self.init();
        }
    },
    _fireInput: function _fireInput() {
        var self = this;
        self.input = self.searchWrapper.querySelector('input');
        self.options = self.searchWrapper.querySelectorAll('.c-search-bar__result a');

        self.inputClickReference = self._showResults.bind(null, self);
        self.inputInputEventReference = self._findValue.bind(null, self);

        self.input.addEventListener('click', self.inputClickReference, false);
        self.input.addEventListener('input', self.inputInputEventReference, false);

        self.outerClickReference = self._outerClick.bind(null, self);
        window.addEventListener('click', self.outerClickReference, false);

        self.options.forEach(function (item) {
            item.addEventListener('click', function (event) {
                self._hideResults();
            });
        });
    },
    _outerClick: function _outerClick(self) {
        var searchBar = document.querySelector('.c-search-bar-barber-shops');

        if (event.target.closest('.c-search-bar') !== searchBar) {
            self._hideResults();
        }
    },
    _showResults: function _showResults(self) {

        var searchResults = self.searchWrapper.querySelector('.c-search-bar__result');
        searchResults.classList.remove('u-display--none');
    },
    _hideResults: function _hideResults() {
        var self = this;
        var searchResults = self.searchWrapper.querySelector('.c-search-bar__result');

        searchResults.classList.add('u-display--none');
    },
    _sanitizeString: function _sanitizeString(value) {
        value = value.toLowerCase();
        value = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        value = value.replace(/[\W_]+/g, '');

        return value;
    },
    _findValue: function _findValue(self) {

        var searchString = self._sanitizeString(event.target.value);

        if (searchString) {
            var searching = searchString;
            self.options.forEach(function (option) {

                self._clearValues(option);

                if (option.dataset.sanitizedValue.indexOf(searching) !== -1) {
                    self._showOption(option);
                } else {
                    self._hideOption(option);
                }
            });

            if (self.searchWrapper.querySelectorAll('.c-search-bar__result a:not(.u-display--none)').length === 0) {
                if (!self.searchWrapper.querySelector('.c-search-bar__result div')) {
                    var elem = document.createElement('div');
                    elem.innerHTML = 'Nothing found';
                    self.searchWrapper.querySelector('.c-search-bar__result').appendChild(elem);
                }
            } else {
                if (self.searchWrapper.querySelector('.c-search-bar__result div')) {
                    self.searchWrapper.querySelector('.c-search-bar__result div').remove();
                }
            }

            return;
        }

        self.options.forEach(function (option) {
            self._showOption(option);
        });

        if (self.searchWrapper.querySelector('.c-search-bar__result div')) {
            self.searchWrapper.querySelector('.c-search-bar__result div').remove();
        }
    },
    _showOption: function _showOption(option) {
        option.classList.remove('u-display--none');
    },
    _hideOption: function _hideOption(option) {
        option.classList.add('u-display--none');
    },
    _clearValues: function _clearValues(option) {
        var self = this;
        option.dataset.sanitizedValue = self._sanitizeString(option.textContent);
    }
};

searchResultsFiltration.init();

document.addEventListener('LokiRequestEnd', function () {
    searchResultsFiltration.reInit();
});

}());
